// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__YoKJW","icon":"SortAdornment_icon__2zHtG","up":"SortAdornment_up__2hzC7","down":"SortAdornment_down__dRdEm","active":"SortAdornment_active__1xNeQ"};